export default {
  search: 'Buscar',
  operation: 'Operación',
  edit: 'Editar',
  submit: 'Enviar',
  re_edit: 'Volver a editar',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  close: 'Cerrar',
  open: 'Abrir',
  drag_file_here: 'Arrastre el archivo aquí, o ',
  click_it_upload: 'Haga clic para subirlo',
  set: 'Configurar',
  change: 'Cambiar',
  next: 'Siguiente',
  previous: 'Anterior',
  update: 'Actualizar',
  detail: 'Detalles',
  show: 'Mostrar',
  send: 'Enviar código',
  re_send: 'Reenviar',
  re_set: 'Restablecer',
  retry: 'Reintentar',
  view: 'Ver',
  clear: 'Limpiar',
  modify: 'Modificar',
  login_out: 'Cerrar sesión',
  home: 'Inicio',
  amount: 'Monto',
  amount_to_receive: 'Monto a recibir',
  amount_non_negative: 'Ingrese un número no negativo',
  amount_integer_only: 'Ingrese un monto entero, solo se admiten números enteros',
  amount_two_decimal_places: 'El monto admite como máximo 2 decimales',
  date: 'Fecha',
  time: 'Hora',
  create_time: 'Fecha de creación',
  transaction_date: 'Fecha de transacción',
  start_date: 'Fecha de inicio',
  end_date: 'Fecha de finalización',
  status: 'Estado',
  link: 'Enlace',
  add: 'Añadir',
  copy: 'Copiar',
  download: 'Descargar',
  handle: 'Gestionar',
  success: 'Éxito',
  back: 'Volver',
  total: 'Total',
  delete: 'Eliminar',
  create: 'Crear',
  email: 'Correo electrónico',
  operator: 'Operador',
  tips: 'Consejos',
  operation_time: 'Fecha y hora de operación',
  last_operator: 'Último operador',
  proceed: 'Proceder',
  notification: 'Notificación',
  reason: 'Motivo',
  create_payment: 'Crear pago',
  refund: 'Reembolso',
  transaction_country: 'País de la transacción',
  complete_time: 'Fecha y hora de finalización',
  filter: 'Filtrar',
  activity: 'Actividad',
  select: 'Seleccionar',
  selected: 'Seleccionado(s)',
  banks: 'Tarjetas bancarias',
  view_details: 'Ver detalles',
  time_zone: 'Zona horaria',
  refresh: 'Actualizar',
  type: 'Tipo',
  action: 'Acción',
  cancel_withdraw: 'Cancelar retiro',
  yes: 'Sí',
  no: 'No',
  click_to_upload: 'Haga clic para subir',
  save: 'Guardar'
}
